import { motion } from "framer-motion";
import { MaskLines, Eyebrow } from "./Reveal";

export const PageHero = ({ eyebrow, lines, intro, img, testId }) => (
  <section data-testid={testId} className="relative pt-36 sm:pt-44 pb-16 sm:pb-24 blueprint overflow-hidden">
    <div className="mx-auto max-w-[1440px] px-5 sm:px-10 grid lg:grid-cols-12 gap-10 items-end">
      <div className="lg:col-span-8">
        <Eyebrow>{eyebrow}</Eyebrow>
        <MaskLines
          lines={lines}
          className="font-display font-extrabold tracking-tight text-5xl sm:text-6xl lg:text-8xl leading-[0.95] mt-6"
        />
      </div>
      <motion.p
        initial={{ opacity: 0, y: 16 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.9, delay: 0.6 }}
        className="lg:col-span-4 text-[#a7aebb] text-base md:text-lg leading-relaxed"
      >
        {intro}
      </motion.p>
    </div>
    {img && (
      <motion.div
        initial={{ clipPath: "inset(0 0 100% 0)" }}
        animate={{ clipPath: "inset(0 0 0% 0)" }}
        transition={{ duration: 1.4, delay: 0.5, ease: [0.7, 0, 0.2, 1] }}
        className="mx-auto max-w-[1440px] px-5 sm:px-10 mt-14 sm:mt-20"
      >
        <img src={img} alt="" className="w-full h-[42vh] sm:h-[60vh] object-cover clip-frame grayscale-[25%]" />
      </motion.div>
    )}
  </section>
);
